module.exports = __webpack_public_path__ + "img/fondo-banner-principal.5254061a.png";